import {useState, useEffect, useContext} from "react";
import { Tabs, Tab } from "@mui/material";
import { TabPanel, TabContext } from "@mui/lab";
import PairingResults from "./PairingResults";
import AttendeeList from "./AttendeeList";
import MatchResults from "./MatchResults";
import GroupResults from "./GroupResults";
import Actions from "./Actions";
import Settings from "./Settings";
// import Printer from "./Printer";
import { EventContext } from "../../../contexts/EventContext";
import { MatchContext } from "../../../contexts/MatchContext";

const EventTabs = ({ showPairings, data }) => {
  const { userData, pairingEvent } = useContext(EventContext);
  const { getData } = useContext(MatchContext);
  const [value, setValue] = useState("1");
  const [printOpen, setPrintOpen] = useState(false);

  useEffect(() => {
    if (showPairings) {
      setValue("2");
    }
  }, [showPairings]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === '1') getData();
  };

  const handlePrint = (val) => {
    setPrintOpen(val);
  };

  const renderActionTab = () => {
    if (
      userData?.permissions?.canViewEventActions ||
      userData?.role === "superadmin"
    ) {
      return <Tab label="Actions" value="4" />;
    }
    return null;
  };

  const renderSettingsTab = () => {
    if (
      userData?.permissions?.canViewEventSettings ||
      userData?.role === "superadmin"
    ) {
      return <Tab label="Settings" value="5" />;
    }
    return null;
  };

  return (
    <div>
      <TabContext value={value}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Attendees" value="1" />
          <Tab label="Pairings" value="2" />
          {['group','dinner'].includes(pairingEvent?.pairingEventType) ? (
            <Tab label="Groups" value="2.5" />
          ) : null}
          <Tab label="Matches" value="3" />
          {renderActionTab()}
          {renderSettingsTab()}
        </Tabs>
        <TabPanel value="1" index={0}>
          {/* <AllEvents user={user} /> */}
          <AttendeeList />
        </TabPanel>
        <TabPanel value="2" index={1}>
          <PairingResults data={data} print={(val) => handlePrint(val)} />
        </TabPanel>
        <TabPanel value="2.5" tabIndex={2.5}>
          <GroupResults />
        </TabPanel>
        <TabPanel value="3" index={2}>
          <MatchResults data={data} print={(val) => handlePrint(val)} />
        </TabPanel>
        <TabPanel value="4" index={3}>
          <Actions />
        </TabPanel>
        <TabPanel value="5" index={4}>
          <Settings />
        </TabPanel>
      </TabContext>
      {/* <Printer open={printOpen} close={() => handlePrint(false)} data={data} /> */}
    </div>
  );
};

export default EventTabs;
